module.exports = __webpack_public_path__ + "static/media/TV.2c8b3b13.png";